/* HALE — reminder-bar placement.
   The bar becomes the first child of <body> and is fixed at top:0 (so it stays
   put while scrolling, on mobile too). Every other element that is pinned to the
   very top of the viewport (announcement strip, header, section wrapper) gets an
   inline `top` equal to the bar height, and <body> gets a matching padding-top,
   so nothing is ever covered. All restored as soon as the bar hides.

   Only elements whose computed `top` is exactly 0px are moved: a bottom-pinned
   bar (mobile tab bar, sticky add-to-cart) has top:auto and must be left alone —
   giving it `top: 52px !important` used to stretch it over the whole screen.
   Full-height overlays (drawer/popup backdrops with inset:0) are skipped too.

   Event-driven: this used to poll every 400 ms for the whole visit, calling
   getComputedStyle on every .shopify-section each time. The triggers below cover
   the same ground — the bar appearing, its .on class flipping, its height
   changing, the viewport resizing, and a header that only turns sticky once the
   page is scrolled. */
(function(){
  var moved = [];
  var SEL = '.hale .announce, .hale header, .shopify-section, header';
  var bar = null;
  var queued = false;

  function activeBar(){ return (bar && bar.classList.contains('on')) ? bar : null; }

  function clear(){
    document.body.style.paddingTop = '';
    if(!moved.length) return;
    moved.forEach(function(m){
      if(m.prev) m.el.style.setProperty('top', m.prev);
      else m.el.style.removeProperty('top');
    });
    moved = [];
  }

  function tick(){
    queued = false;
    if(!bar || !bar.isConnected){
      clear();
      return;
    }
    if(document.body.firstElementChild !== bar){
      document.body.insertBefore(bar, document.body.firstElementChild);
    }

    if(!activeBar()){
      document.documentElement.style.setProperty('--hale-cbar-h', '0px');
      clear();
      return;
    }

    var h = Math.round(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--hale-cbar-h', h + 'px');
    if(!h) return;

    /* The page offset is written as a concrete px value here, NOT left to the
       stylesheet's padding-top:var(--hale-cbar-h).

       padding-top is transitioned (so the page glides down together with the
       bar instead of jumping), and a transitioned property whose value comes
       from a custom property freezes at whatever that variable held when the
       transition began. hale-cart-remind.js adds .hale-cbar-pad in the same
       breath as .on — before this script has had a chance to measure the bar —
       so the variable was still 0px, the transition ran 0 → 0, and every later
       change to --hale-cbar-h was ignored: measured 0px of padding against a
       55px bar, which sat straight on top of the announcement strip and the
       header. An explicit px value re-applies on every tick and animates
       normally. */
    if(document.body.style.paddingTop !== h + 'px'){
      document.body.style.paddingTop = h + 'px';
    }

    var vh = window.innerHeight || 0;
    [].forEach.call(document.querySelectorAll(SEL), function(el){
      if(el === bar || (el.contains && el.contains(bar))) return;
      var cs;
      try { cs = getComputedStyle(el); } catch(e){ return; }
      if(cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if(cs.top !== '0px') return;                        /* not pinned to the top */
      if(vh && el.getBoundingClientRect().height > vh * 0.6) return;  /* overlay */

      var known = null;
      for(var i = 0; i < moved.length; i++){ if(moved[i].el === el){ known = moved[i]; break; } }
      if(!known) moved.push({ el: el, prev: el.style.top || '' });
      el.style.setProperty('top', h + 'px', 'important');
    });
  }

  /* coalesce bursts of triggers into one pass per frame */
  function schedule(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(tick);
    setTimeout(function(){ if(queued) tick(); }, 100);   /* rAF is paused in background tabs */
  }

  /* (re)bind the per-bar observers whenever the bar node itself changes */
  function attach(){
    var found = document.querySelector('.hale-cbar');
    if(found === bar) return;
    bar = found;
    if(!bar) return;
    new MutationObserver(schedule).observe(bar, { attributes:true, attributeFilter:['class','style'] });
    if(window.ResizeObserver) new ResizeObserver(schedule).observe(bar);
  }

  function boot(){
    attach();
    schedule();
    /* the bar is created by hale-cart-remind.js at some later point */
    new MutationObserver(function(){ attach(); schedule(); })
      .observe(document.body, { childList: true });
  }

  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  /* a header that only becomes position:sticky after some scrolling */
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
})();
